// Module
var code = "<template>\n  <div class=\"tolerance__wrapper\">\n    ${mainValue} <span class=\"tolerance\"> <span class=\"tolerance__up\">+${valueToleranceUp}%</span><span class=\"tolerance__down\">-${valueToleranceDown}%</span></span>\n  </div>\n</template>\n";
// Exports
export default code;